import { motion } from "motion/react";
import CountUp from "@/components/CountUp";
import { stats } from "@/mocks/home";

const statValues = [
  { end: 15, suffix: "+" },
  { end: 100, suffix: "%" },
  { end: 20, suffix: "+" },
  { end: 2000, suffix: "+" },
];

export default function StatsSection() {
  return (
    <section className="py-10 md:py-14 bg-primary">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.12 }}
              className="flex flex-col items-center text-center"
            >
              <div className="text-3xl md:text-4xl font-bold text-accent mb-2">
                <CountUp
                  end={statValues[index].end}
                  suffix={statValues[index].suffix}
                  duration={2}
                />
              </div>
              <motion.div
                whileHover={{ scale: 1.15, rotate: 5 }}
                transition={{ type: "spring", stiffness: 300 }}
                className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/10 mb-3"
              >
                <i className={`${stat.icon} text-accent text-xl md:text-2xl`}></i>
              </motion.div>
              <h3 className="text-xs md:text-sm font-bold text-white tracking-wide uppercase">
                {stat.title}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}